import React from 'react';

import { Empty as AntdEmpty } from 'antd';
import { Associative } from '../../types';

export const Empty: React.FC<{
  isLoading?: boolean;
  style?: Associative;
  description?: string;
}> = ({ isLoading, style = {}, description }) => (
  <AntdEmpty
    image={AntdEmpty.PRESENTED_IMAGE_SIMPLE}
    description={
      isLoading ? "Les données n'ont pas pu être chargées" : description
    }
    style={{ ...style, marginTop: '50px' }}
  />
);
